"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Backdrop = _interopRequireDefault(require("@mui/material/Backdrop"));
var _Modal = _interopRequireDefault(require("@mui/material/Modal"));
var _styles = require("@mui/material/styles");
var _styles2 = require("../styles");
var _excluded = ["children", "classes", "invisible", "onClick", "open", "className", "transitionDuration", "disableScrollLock"];
var styles = function styles(theme) {
  return {
    root: {
      zIndex: theme.zIndex.backdrop,
      '&:focus': {
        outline: 'none'
      },
      backgroundColor: (0, _styles.alpha)(theme.palette.grey[600], 0.3)
    },
    invisible: {
      backgroundColor: 'transparent'
    }
  };
};

/**
 * Backdrop places a tinted, full-screen backdrop over the application.
 *
 * @done true
 * @updated v7.0.0
 * @versionAdded v4.4.0
 * @examples
 *  BackdropExample
 */
var Backdrop = function Backdrop(props) {
  var children = props.children,
    classes = props.classes,
    invisible = props.invisible,
    onClick = props.onClick,
    open = props.open,
    className = props.className,
    transitionDuration = props.transitionDuration,
    disableScrollLock = props.disableScrollLock,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = {
    root: classes.root,
    invisible: classes.invisible
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    open: open,
    disableScrollLock: disableScrollLock,
    hideBackdrop: true
  }, /*#__PURE__*/_react.default.createElement(_Backdrop.default, (0, _extends2.default)({
    invisible: invisible,
    className: className,
    classes: classOverrides,
    open: open,
    in: open,
    onClick: onClick,
    transitionDuration: transitionDuration
  }, rest), children));
};
Backdrop.muiName = 'Backdrop';
Backdrop.propTypes = {
  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes.default.bool.isRequired,
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * @ignore
   * The components used for each slot inside the Backdrop.
   * Either a string to use a HTML element or a component.
   */
  components: _propTypes.default.shape({
    Root: _propTypes.default.elementType
  }),
  /**
   * @ignore
   * The props used for each slot inside the Backdrop.
   */
  componentsProps: _propTypes.default.shape({
    root: _propTypes.default.object
  }),
  /**
   * If `true`, allows background scrolling while the Backdrop is visible.
   */
  disableScrollLock: _propTypes.default.bool,
  /**
   * If `true`, the backdrop is invisible.
   *
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes.default.bool,
  /**
   * Event handler that fires when the user clicks on an active backdrop.
   */
  onClick: _propTypes.default.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * The duration for the transition, in milliseconds.
   *
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Object format:
   *
   * ```
   * {
   *     appear: number,
   *     enter: number,
   *     exit: number
   * }
   * ```
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    appear: _propTypes.default.number,
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
};
Backdrop.defaultProps = {
  invisible: false,
  disableScrollLock: false
};
var _default = exports.default = (0, _styles2.withStyles)(styles)(Backdrop);